import * as React from 'react';

import { ERentTime, getTermValue } from '../../../../../JsonQuery';
import { DEFAULT_LONGTERM_RENT_OPTION } from '../../../../../JsonQuery/constants';
import { useContext } from '../../../utils/useContext';
import { RentalPeriod } from '../../../components/advancedFilters/RentalPeriod';

export const RentalPeriodContainer: React.FC = () => {
  const { jsonQuery, onChange } = useContext();
  let rentalPeriod = getTermValue('for_day')(jsonQuery);
  if (rentalPeriod === null) {
    rentalPeriod = DEFAULT_LONGTERM_RENT_OPTION;
  }

  const handleChange = React.useCallback(
    (rentalPeriod: ERentTime) => {
      onChange({ action: 'setRentalPeriod', arguments: [rentalPeriod] });
    },
    [onChange],
  );

  return <RentalPeriod value={rentalPeriod} onChange={handleChange} />;
};
